const SCROLL_THRESHOLD_RATIO = 0.25;
const MIN_SCROLLABLE_PX = 200;
const SCROLL_DURATION_MS = 500;

function getScrollableHeight() {
	return Math.max(
		document.documentElement.scrollHeight - window.innerHeight,
		0,
	);
}

function getDeviceType() {
	const ua = navigator.userAgent || "";
	if (/Mobi|Android|iPhone|iPod/i.test(ua)) return "mobile";
	if (/iPad|Tablet/i.test(ua)) return "tablet";
	return "desktop";
}

function prefersReducedMotion() {
	return (
		window.matchMedia &&
		window.matchMedia("(prefers-reduced-motion: reduce)").matches
	);
}

function easeInOutCubic(t) {
	return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

function animatedScrollToTop(duration) {
	const start = window.pageYOffset || document.documentElement.scrollTop;
	if (start === 0) return;

	const startTime = performance.now();

	function step(now) {
		const elapsed = now - startTime;
		const progress = Math.min(elapsed / duration, 1);
		const value = start * (1 - easeInOutCubic(progress));
		window.scrollTo(0, value);
		if (progress < 1) window.requestAnimationFrame(step);
	}

	window.requestAnimationFrame(step);
}

function smoothScrollToTop() {
	if (prefersReducedMotion()) {
		window.scrollTo(0, 0);
		return;
	}

	const supportsNativeSmooth =
		"scrollBehavior" in document.documentElement.style;

	if (supportsNativeSmooth) {
		try {
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
			return;
		} catch (_) {
			// Fall through to manual animation.
		}
	}

	animatedScrollToTop(SCROLL_DURATION_MS);
}

function trackClickAnalytics(button) {
	try {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: "return_to_top_clicked",
			page_type: button.dataset.pageType || "unknown",
			device_type: getDeviceType(),
		});
	} catch (_) {
		/* analytics is best-effort */
	}
}

class BackToTopController {
	constructor(button) {
		this.button = button;
		this.isVisible = false;
		this.scrollScheduled = false;

		this.button.removeAttribute("hidden");

		this.handleScroll = this.handleScroll.bind(this);
		this.handleResize = this.handleScroll;
		this.handleClick = this.handleClick.bind(this);
		this.handleTouchEnd = this.handleTouchEnd.bind(this);

		this.button.addEventListener("click", this.handleClick);
		this.button.addEventListener("touchend", this.handleTouchEnd, {
			passive: false,
		});
		window.addEventListener("scroll", this.onScroll.bind(this), {
			passive: true,
		});
		window.addEventListener("resize", this.onScroll.bind(this), {
			passive: true,
		});

		this.handleScroll();
	}

	onScroll() {
		if (this.scrollScheduled) return;
		this.scrollScheduled = true;
		window.requestAnimationFrame(() => {
			this.scrollScheduled = false;
			this.handleScroll();
		});
	}

	handleScroll() {
		const scrollable = getScrollableHeight();

		if (scrollable < MIN_SCROLLABLE_PX) {
			this.setVisible(false);
			return;
		}

		const scrolled = window.pageYOffset || document.documentElement.scrollTop;
		const ratio = scrolled / scrollable;
		this.setVisible(ratio >= SCROLL_THRESHOLD_RATIO);
	}

	setVisible(visible) {
		if (visible === this.isVisible) return;
		this.isVisible = visible;
		this.button.classList.toggle("is-visible", visible);
		this.button.setAttribute("aria-hidden", visible ? "false" : "true");
		this.button.tabIndex = visible ? 0 : -1;
	}

	handleClick(event) {
		event.preventDefault();
		trackClickAnalytics(this.button);
		smoothScrollToTop();
	}

	handleTouchEnd(event) {
		event.preventDefault();
		this.handleClick(event);
	}
}

function init() {
	const button = document.querySelector("[data-back-to-top]");
	if (!button || button.dataset.backToTopInit === "true") return;
	button.dataset.backToTopInit = "true";
	new BackToTopController(button);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
